import { all, fork, put, takeLatest, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';
import {
    getTemples as getTemplesApi,
    addTemple as addTempleApi,
    getTempleDetails,
    updateTempleDetails,
    deleteTempleByIdApi,
} from 'helpers/api/temples';
import { templeApiResponseSuccess, templeApiResponseError } from './actions';
import { TempleActionTypes } from './constants';

/**
 * Fetches temples from the API
 */
function* getTemples({ payload: { limit, page, sortType } }: any): SagaIterator {
    try {
        const response = yield call(getTemplesApi, { limit, page, sortType });
        const temples = response.data;
        yield put(templeApiResponseSuccess(TempleActionTypes.GET_TEMPLES, temples));
    } catch (error: any) {
        console.log('Error fetching temples:', error);
        yield put(templeApiResponseError(TempleActionTypes.GET_TEMPLES, error));
    }
}

function* addTempleSaga({ payload: templeDetails }: any): SagaIterator {
    try {
        const response = yield call(addTempleApi, templeDetails);
        const createdTemple = response?.data;
        yield put(templeApiResponseSuccess(TempleActionTypes.ADD_TEMPLE, createdTemple));
    } catch (error: any) {
        yield put(templeApiResponseError(TempleActionTypes.ADD_TEMPLE, error));
    }
}

function* getTempleDetailsByIdSaga(action: any): SagaIterator {
    try {
        const response = yield call(getTempleDetails, action.payload);
        const templeDetails = response.data;
        yield put(templeApiResponseSuccess(TempleActionTypes.GET_TEMPLE_DETAILS, templeDetails));
    } catch (error: any) {
        yield put(templeApiResponseError(TempleActionTypes.GET_TEMPLE_DETAILS, error));
    }
}

function* updateTempleByIdSaga(action: any): SagaIterator {
    try {
        const response = yield call(updateTempleDetails, action.payload);
        const updatedTempleDetails = response.data;
        yield put(templeApiResponseSuccess(TempleActionTypes.UPDATE_TEMPLE, updatedTempleDetails));
    } catch (error: any) {
        yield put(templeApiResponseError(TempleActionTypes.UPDATE_TEMPLE, error));
    }
}

function* deleteTempleByIdSaga(action: any): SagaIterator {
    try {
        yield call(deleteTempleByIdApi, action.payload);
        yield put(
            templeApiResponseSuccess(
                TempleActionTypes.DELETE_TEMPLE,
                action.payload
            )
        );
    } catch (error: any) {
        yield put(templeApiResponseError(TempleActionTypes.DELETE_TEMPLE, 'Failed to delete Temple'));
    }
}

export function* watchGetTemples() {
    yield takeLatest(TempleActionTypes.GET_TEMPLES, getTemples);
}

export function* watchAddTemple() {
    yield takeEvery(TempleActionTypes.ADD_TEMPLE, addTempleSaga);
}

export function* watchUpdateTempleById() {
    yield takeEvery(TempleActionTypes.UPDATE_TEMPLE, updateTempleByIdSaga);
}

export function* watchGetTempleDetailsById() {
    yield takeLatest(TempleActionTypes.GET_TEMPLE_DETAILS, getTempleDetailsByIdSaga);
}

export function* watchDeleteTempleById() {
    yield takeEvery(TempleActionTypes.DELETE_TEMPLE, deleteTempleByIdSaga);
}

/**
 * Root temple saga
 */
function* templeSaga() {
    yield all([
        fork(watchGetTemples),
        fork(watchAddTemple),
        fork(watchGetTempleDetailsById),
        fork(watchUpdateTempleById),
        fork(watchDeleteTempleById),
    ]);
}

export default templeSaga;
